type FacebookEvent = 'track' | 'trackCustom';

export const trackFacebookEvent = (
  type: FacebookEvent,
  event: string,
  meta?: Record<string, undefined | string | number | string[]>
) => window?.fbq?.call(window.fbq, type, event, meta);
